import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next';

export const mutateChangelogUpdate = ({ entryId }) => {
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationKey: ['changelog-update', entryId],
        mutationFn: async (formData) => {
            const res = await axios.put(route('studio.v1.api.changelog.update', entryId), formData);
            return res;
        },
        onSuccess: async () => {
            notifications.show({
                color: 'green',
                title: t('common.success'),
                message: t('changelog.entry.updated'),
            })
        },
        onError: async ({ response }) => {
            notifications.show({
                color: 'red',
                title: t('common.error'),
                message: response?.data?.message || "",
            })
        }
    });

    return mutation;
}
